
import { useProfileResources } from '@profile';

export default function () {
    const profile = useProfileResources('Profile');
    profile.delete();
}
